var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgExamWarning = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1 8.6L11.9 8.8C11.2 8.9 10.5 8.4 10.4 7.7L10.2 5.5H10.3L14.1 8.6Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9 16.7999C15 17.4999 14.4 18.1999 13.7 18.1999L6.69996 18.8999H6.59996H6.39996C5.69996 18.9999 4.99996 18.3999 4.99996 17.6999L3.99996 7.3999C3.89996 6.6999 4.49996 5.9999 5.19996 5.8999L10.2 5.3999H10.3L10.5 7.5999C10.5 7.7999 10.6 7.8999 10.6 8.0999C10.7 8.1999 10.8 8.3999 10.9 8.4999C11.2 8.6999 11.5 8.8999 11.9 8.7999H12.1H12.2L14.1 8.5999L14.9 16.7999Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6 8.5999H14.2H14.1L12.4 8.7999C12.3 8.7999 12.3 8.7999 12.2 8.7999C11.6 8.7999 11.1 8.2999 11 7.6999L10.8 5.8999V5.7999V5.3999H10.9L14.6 8.5999Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9 16.8C15 17.5 14.4 18.2 13.7 18.2L6.7 18.9C6.1 18.9 5.6 18.4 5.5 17.7L4.5 7.3C4.5 6.6 5 6 5.7 5.9L10.2 5.5H10.3H10.6H10.7V5.9V6L11 7.7C11.1 8.3 11.6 8.8 12.2 8.9C12.3 8.9 12.3 8.9 12.4 8.9L14.1 8.7L14.9 16.8Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2001 8H14.6001C13.8001 8 13.1001 7.3 13.1001 6.5V4L13.2001 4.1L17.2001 8Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2 8.1V17.5C17.2 18.3 16.5 19 15.7 19H7.30005C6.50005 19 5.80005 18.3 5.80005 17.5V5.5C5.80005 4.7 6.50005 4 7.30005 4H13H13.1V6.5C13.1 7.3 13.8 8 14.6 8H17.2V8.1Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2 8.1V17.5C17.2 18.3 16.5 19 15.7 19H8C7.2 19 6.5 18.3 6.5 17.5V5.5C6.5 4.7 7.2 4 8 4H13H13.1V6.5C13.1 7.3 13.8 8 14.6 8H17.2V8.1Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6999 10.5H9.09985C8.79985 10.5 8.59985 10.3 8.59985 10C8.59985 9.7 8.79985 9.5 9.09985 9.5H14.5999C14.8999 9.5 15.0999 9.7 15.0999 10C15.0999 10.3 14.8999 10.5 14.6999 10.5Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6999 13.3999H9.09985C8.79985 13.3999 8.59985 13.1999 8.59985 12.8999C8.59985 12.5999 8.79985 12.3999 9.09985 12.3999H14.5999C14.8999 12.3999 15.0999 12.5999 15.0999 12.8999C15.0999 13.1999 14.8999 13.3999 14.6999 13.3999Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2999 15.8H9.09985C8.79985 15.8 8.59985 15.6 8.59985 15.3C8.59985 15 8.79985 14.8 9.09985 14.8H12.1999C12.4999 14.8 12.6999 15 12.6999 15.3C12.6999 15.6 12.4999 15.8 12.2999 15.8Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1001 19.9999H14.3001C13.6001 19.9999 13.2001 19.2999 13.6001 18.7999L16.0001 14.6999C16.2001 14.3999 16.6001 14.1999 16.9001 14.2999C17.1001 14.2999 17.3001 14.4999 17.4001 14.6999L19.8001 18.7999C20.2001 19.2999 19.8001 19.9999 19.1001 19.9999Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1 20H14.7C14 20 13.6 19.3 14 18.8L16.4 14.7C16.5 14.5 16.7 14.4 16.9 14.3C17.1 14.3 17.3 14.5 17.4 14.7L19.8 18.8C20.2 19.3 19.8 20 19.1 20Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9001 18.0999C16.8001 18.0999 16.6001 17.9999 16.6001 17.7999V15.8999C16.6001 15.7999 16.7001 15.5999 16.9001 15.5999C17.1001 15.5999 17.2001 15.6999 17.2001 15.8999V17.7999C17.2001 17.9999 17.1001 18.0999 16.9001 18.0999Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9 19.3C17.1209 19.3 17.3 19.1209 17.3 18.9C17.3 18.6791 17.1209 18.5 16.9 18.5C16.6791 18.5 16.5 18.6791 16.5 18.9C16.5 19.1209 16.6791 19.3 16.9 19.3Z",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8002 18.0999C16.7002 18.0999 16.5002 17.9999 16.5002 17.7999V15.8999C16.5002 15.7999 16.6002 15.5999 16.8002 15.5999C16.9002 15.5999 17.1002 15.6999 17.1002 15.8999V17.7999C17.1002 17.9999 17.0002 18.0999 16.8002 18.0999Z",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8001 19.2998C17.0211 19.2998 17.2001 19.1207 17.2001 18.8998C17.2001 18.6788 17.0211 18.4998 16.8001 18.4998C16.5792 18.4998 16.4001 18.6788 16.4001 18.8998C16.4001 19.1207 16.5792 19.2998 16.8001 19.2998Z",
    fill: "url(#paint15_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10.2405,
    y1: 8.87498,
    x2: 11.9412,
    y2: 7.2478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 14.0549,
    y1: 9.4571,
    x2: -4.82514,
    y2: 20.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B82A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 14.514,
    y1: 4.46676,
    x2: 7.39947,
    y2: 14.5461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 3.2076,
    y1: 6.2148,
    x2: 13.9013,
    y2: 17.8384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B82A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 16.6317,
    y1: 4.6655,
    x2: 11.6485,
    y2: 9.1957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 15.7434,
    y1: 7.965,
    x2: -0.225452,
    y2: 21.2158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 15.8976,
    y1: 2.8784,
    x2: 1.854,
    y2: 32.7776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 1.73925,
    y1: 9.9114,
    x2: 14.8574,
    y2: 10.1189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 1.69465,
    y1: 12.7309,
    x2: 14.8128,
    y2: 12.9385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 1.65555,
    y1: 15.2064,
    x2: 14.7736,
    y2: 15.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 19.7056,
    y1: 16.6538,
    x2: 14.1641,
    y2: 18.2371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 14.4283,
    y1: 15.1366,
    x2: 17.5769,
    y2: 19.9225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 16.3625,
    y1: 16.7303,
    x2: 16.9335,
    y2: 16.8871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 15.7261,
    y1: 18.5781,
    x2: 17.5232,
    y2: 18.9987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 16.8308,
    y1: 15.9397,
    x2: 16.8218,
    y2: 18.0538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 16.8481,
    y1: 18.6352,
    x2: 16.7851,
    y2: 19.3009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExamWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ExamWarning.c5dbea08.svg";
export { ForwardRef as ReactComponent };